import React from "react";
import {
  Button,
  Card,
  Dialog,
  IconButton,
  Input,
  Option,
  Radio,
  Select,
} from "@material-tailwind/react";
import { RiCloseCircleLine } from "react-icons/ri";
import ReactSelect from "react-select";

function ManageEventsModal({
  open,
  close,
  data,
  batch_items,
  handleChange,
  setData,
  handleFetchBatchDetails,
  selectedItems,
  handleSubmit,
}) {
  return (
    <div>
      <Dialog size="md" open={open} className="bg-transparent shadow-none">
        <Card className="w-full p-5">
          <div className="flex justify-between">
            <h1 className="text-xl font-bold text-gray-800 font-ddin mb-5">
              {data?.editable ? "Update" : "Add"} Event
            </h1>
            <IconButton
              color="blue-gray"
              size="sm"
              variant="text"
              className="rounded-full hover:text-red-900 hover:bg-red-100"
              onClick={close}
            ></IconButton>
          </div>

          <form
            className="mb-2 w-auto flex flex-col gap-3"
            onSubmit={handleSubmit}
            // onSubmit={data.editable ? handleUpdate : handleSubmit}
          >
            <Input
              label="Event name"
              className="p-3"
              name="title"
              style={{ fontFamily: "D-DIN", fontWeight: 500 }}
              containerProps={{
                className: "font-ddin",
              }}
              onChange={handleChange}
              value={data?.title}
              required
            />
            <Input
              label="Event URL"
              className="p-3"
              name="url"
              style={{ fontFamily: "D-DIN", fontWeight: 500 }}
              containerProps={{
                className: "font-ddin",
              }}
              value={data.url}
              onChange={handleChange}
            />
            <div className="relative w-full">
              <textarea
                name="description"
                rows={3}
                placeholder=" "
                value={data?.description}
                onChange={handleChange}
                className="peer w-full border border-blue-gray-200 rounded-[7px] px-3 pt-4 pb-2 font-ddin text-sm resize-none focus:outline-none focus:border-gray-900 transition-all"
              />
              <label className="absolute left-3 top-2 text-xs text-gray-500 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs transition-all font-ddin">
                Description
              </label>
            </div>
            <Input
              label="Event start Date"
              type="date"
              name="time"
              style={{ fontFamily: "D-DIN", fontWeight: 500 }}
              containerProps={{
                className: "font-ddin",
              }}
              value={
                data.time ? new Date(data.time).toISOString().split("T")[0] : ""
              }
              onChange={(e) => {
                const dateValue = e.target.value;
                if (dateValue) {
                  // Append 'T00:00:00' to create full datetime string
                  const fullDateTime = `${dateValue}T00:00:00`;
                  setData({ ...data, time: fullDateTime });
                } else {
                  setData({ ...data, time: "" });
                }
              }}
              required
            />

            <Select
              label="Select a Batch"
              name="batch_name"
              style={{ fontFamily: "D-DIN", fontWeight: 500 }}
              containerProps={{
                className: "font-ddin",
              }}
              value={data.batch_name}
              onChange={(e) => {
                setData({ ...data, batch_name: e });
                handleFetchBatchDetails(e);
              }}
            >
              {batch_items?.map((item, i) => (
                <Option
                  key={i}
                  value={item.batch_id}
                  style={{ fontFamily: "D-DIN" }}
                >
                  {item.name}
                </Option>
              ))}
            </Select>

            {data.batch_name && (
              <div className="flex items-center gap-5">
                <Radio
                  name="student_type"
                  value="1"
                  label="All"
                  onChange={handleChange}
                />
                <Radio
                  name="student_type"
                  value="2"
                  label="Only with"
                  onChange={handleChange}
                />
              </div>
            )}

            {data.student_type == 2 && (
              <ReactSelect
                isMulti
                name="students"
                options={selectedItems[0]?.students?.map((student, i) => ({
                  value: student.student_id,
                  label: student.name,
                }))}
                className="basic-multi-select font-ddin"
                classNamePrefix="select"
                onChange={(e) => setData({ ...data, students: e })}
                required
              />
            )}

            <div className="flex justify-end mt-3">
              <Button
                type="submit"
                className="shadow-none hover:shadow-none capitalize py-2 font-ddin font-normal text-base border-[#DD4633] border bg-transparent text-[#DD4633] hover:text-white hover:bg-[#DD4633] disabled:cursor-not-allowed"
              >
                Submit
              </Button>
            </div>
          </form>
        </Card>
      </Dialog>
    </div>
  );
}

export default ManageEventsModal;
